/**
 * Created by user on 2019/7/26.
 */
export * from '@lazy-cjk/jp-table-alias';
import m from '@lazy-cjk/jp-table-alias';

export default m;
